import React from "react";
import { render } from "react-dom";
import ajaxError from "../helpers/ajaxError";
class FavoritesItem extends React.Component {
	constructor(props) {
		super(props);
		this.deleteFavorite = this.deleteFavorite.bind(this);
	}
	deleteFavorite(event) {
		const favorites = require("../helpers/favorites");

		var id = event.target.parentNode.getAttribute("data-id");
		var url = links.api.favorite
			.replace("_SK_", window.session_key)
			.replace("_ID_", id);

		$.ajax({
			url: url,
			cache: false
		})
			.done(function() {
				window.favorites = $.grep(window.favorites, function(e) {
					return e.id != id;
				});
				localStorage.setItem(
					"games_favorites",
					JSON.stringify(window.favorites)
				);
				render(
					<Favoritos items={window.favorites} />,
					document.getElementById("FavoritosContainer")
				);

				if ($("body").attr("data-section") == "game-screen") {
					favorites.buttonCheck("#add_favorite");
				}
			})
			.fail(ajaxError);
	}
	render() {
		return (
			<li data-id={this.props.id} data-type="fav">
				<a href={this.props.url}>
					<img
						height={window.mobile ? 60 : 30}
						width={window.mobile ? 60 : 50}
						src={this.props.img}
					/>
					{this.props.name}
				</a>
				<i
					onClick={this.deleteFavorite}
					className="fa fa-times favorites-remove"
				/>
			</li>
		);
	}
}

class Favoritos extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		var rows = [];
		this.props.items.forEach((result, key) => {
			rows.push(
				<FavoritesItem
					key={key}
					id={result.id}
					url={result.url}
					img={result.img}
					name={result.name}
				/>
			);
		});
		if (!window.mobile) {
			return (
				<div>
					<a href="javascript:void(0);">
						<span className="s_icon_o" width="21" height="21" />
						{translate.favoritos}
					</a>
					{this.props.items.length == 0 ? (
						<ul className="sub-menu" id="fav_submenu">
							<li>{translate.favoritos_description}</li>
						</ul>
					) : (
						<ul className="sub-menu" id="fav_submenu">
							{rows}
						</ul>
					)}
				</div>
			);
		} else {
			if (this.props.items.length == 0) {
				return (
					<ul className="mm-listview">
						<li className="nogames">{translate.favoritos_description}</li>
					</ul>
				);
			} else {
				return <ul className="mm-listview">{rows}</ul>;
			}
		}
	}
}

export default Favoritos;
